/** This export is automatically generated */
export const gitHash = '11af79efc';
